import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App.tsx";

// Roboto, the ZFP design's typeface, from the package; nothing else loads a font
import "@zfp-akademie-a-s/zfp-design/fonts.css";

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
